import { render } from "./ContactoSection.vue.vue?vue&type=template&id=96dbbb14&scoped=true"
import script from "./ContactoSection.vue.vue?vue&type=script&lang=js"
export * from "./ContactoSection.vue.vue?vue&type=script&lang=js"

import "./ContactoSection.vue.vue?vue&type=style&index=0&id=96dbbb14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96dbbb14"]])

export default __exports__